import type { RbacMembership } from '../services/rbacAdminApi';

/** Blank or whitespace-only site → null (org-wide). */
export function normalizeSiteIdForScope(raw: string | undefined | null): string | null {
  const t = String(raw ?? '').trim();
  return t || null;
}

/** Stable key for org + site scope (site null/empty = org-wide bucket). */
export function scopeKey(orgId: string, siteId: string | null | undefined): string {
  const o = String(orgId ?? '').trim();
  const s = normalizeSiteIdForScope(siteId);
  return `${o}\0${s ?? ''}`;
}

export function findMembershipAtScope(
  memberships: RbacMembership[],
  orgId: string,
  siteId: string | null,
): RbacMembership | undefined {
  const o = String(orgId ?? '').trim();
  return memberships.find((m) => {
    const mo = String(m.org_id ?? '').trim();
    const ms = normalizeSiteIdForScope(m.site_id);
    const want = siteId;
    return mo === o && (ms ?? '') === (want ?? '');
  });
}

/** Groups of two+ rows sharing the same scope (data inconsistency until healed). */
export function findDuplicateScopeStacks(memberships: RbacMembership[]): RbacMembership[][] {
  const map = new Map<string, RbacMembership[]>();
  for (const m of memberships) {
    const k = scopeKey(m.org_id, m.site_id);
    if (!map.has(k)) map.set(k, []);
    map.get(k)!.push(m);
  }
  return Array.from(map.values()).filter((arr) => arr.length > 1);
}
